/* eslint-disable @typescript-eslint/no-unused-vars */
import { useContext } from "react";
import { PlayheadContext } from "../Context/PlayheadContext/PlayheadContext";

export function useTimerCalulatedData(_?: string) {
	const playheadContext = useContext(PlayheadContext);

	return playheadContext.state;
}
